import * as React from "react";
const SvgLess32 = props => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path fillRule="evenodd" d="M4 16c0-.411.333-.745.745-.745h22.51a.745.745 0 1 1 0 1.49H4.745A.745.745 0 0 1 4 16" clipRule="evenodd" /></svg>;
export default SvgLess32;